import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ContractReportRequest, ContractReportResponse } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const ContractReportsActions = createActionGroup({
    source: "Contract Admin / Contract Reports",
    events: {
        "Generate Contract Report": props<{ request: ContractReportRequest }>(),
        "Generate Contract Report Success": props<{ response: ContractReportResponse }>(),
        "Generate Contract Report Failure": props<{ error: AppError; toastKey: string }>(),
        "Export Contract Report Excel": props<{ request: ContractReportRequest }>(),
        "Export Contract Report Excel Success": props<{ toastKey: string }>(),
        "Export Contract Report Excel Failure": props<{ error: AppError; toastKey: string }>(),
        "Clear Contract Report": emptyProps(),
    },
});
